export const NOTIFICATION_CHANGE_ATTRIBUTE = 'NOTIFICATION_CHANGE_ATTRIBUTE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SET_NOTIFICATION_SNACKBAR_ERROR =
  'set_notification_snackbar_error';

// NOTIFICATION STATES
export const VISIBLE = 'visible';
export const FORCE = 'force';
